interface ModifyClassesOptions {
    addClasses?: string[];
    removeClasses?: string[];
}

interface AnimationOptions extends ModifyClassesOptions {
    addClassesAfterDuration?: boolean;
    removeClassesAfterDuration?: boolean;
    callback?: () => void;
    animateOnlyIfToggled?: boolean;
}

interface SlideAnimationOptions extends AnimationOptions {
    distance?: number;
    toggle?: HTMLElement;
}

export const show = (element?: HTMLElement | null, options?: ModifyClassesOptions) => {
    if (element) {
        element.style.removeProperty('display');
        const display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;
        options?.addClasses && element.classList.add(...options.addClasses);
        options?.removeClasses && element.classList.remove(...options.removeClasses);
        element.offsetHeight;
    }
};

export const hide = (element?: HTMLElement | null, options?: ModifyClassesOptions) => {
    if (element) {
        element.style.display = 'none';
        options?.addClasses && element.classList.add(...options.addClasses);
        options?.removeClasses && element.classList.remove(...options.removeClasses);
    }
};

export const fadeIn = (element?: HTMLElement | null, duration: number = 200, options?: AnimationOptions) => {
    if (element && (options?.animateOnlyIfToggled === undefined || (options?.animateOnlyIfToggled && window.getComputedStyle(element).display === 'none'))) {
        element.style.removeProperty('display');	
        const display = window.getComputedStyle(element).display;
        element.style.opacity = '0';
        element.style.visibility = 'hidden';
        element.style.display = display === 'none' ? 'block' : display;
        
        // Force CSS Reflow
        element.offsetHeight;
        
        element.style.transition = `opacity ${duration}ms linear`;
        element.style.visibility = 'visible';
        element.style.opacity = '1';
    
        if (options?.addClasses && !options.addClassesAfterDuration) {
            element.classList.add(...options.addClasses);
        }

        if (options?.removeClasses && !options.removeClassesAfterDuration) {
            element.classList.remove(...options.removeClasses);
        }

        setTimeout(() => {
            element.style.removeProperty('opacity');
            element.style.removeProperty('visibility');
            element.style.removeProperty('transition');

            options?.callback?.();

            if (options?.addClasses && options.addClassesAfterDuration) {
                element.classList.add(...options.addClasses);
            }
            
            if (options?.removeClasses && options.removeClassesAfterDuration) {
                element.classList.remove(...options.removeClasses);
            }
        }, duration);
    }
};

export const fadeOut = (element?: HTMLElement | null, duration : number = 200, options?: AnimationOptions) => {
    if (element && (options?.animateOnlyIfToggled === undefined || (options?.animateOnlyIfToggled && window.getComputedStyle(element).display !== 'none'))) {
        element.style.transition = `opacity ${duration}ms linear`;
        element.style.opacity = '0';

        // Force CSS Reflow
        element.offsetHeight;

        if (options?.addClasses && !options.addClassesAfterDuration) {
            element.classList.add(...options.addClasses);
        }

        if (options?.removeClasses && !options.removeClassesAfterDuration) {
            element.classList.remove(...options.removeClasses);
        }

        setTimeout(() => {
            element.style.display = 'none';
            element.style.removeProperty('transition');
            element.style.removeProperty('opacity');

            options?.callback?.();

            if (options?.addClasses && options.addClassesAfterDuration) {
                element.classList.add(...options.addClasses);
            }
            
            if (options?.removeClasses && options.removeClassesAfterDuration) {
                element.classList.remove(...options.removeClasses);
            }
        }, duration);
    }
};

export const fadeToggle = (element?: HTMLElement | null, duration: number = 200, options?: AnimationOptions) => {
    if (element) {
        if (window.getComputedStyle(element).display === 'none') {
                return fadeIn(element, duration, options);
        } else {
                return fadeOut(element, duration, options);
        }
    }
};

export const slideUp = (element?: HTMLElement | null, duration: number = 200, options?: AnimationOptions) => {
    if (element) {
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = element.offsetHeight + 'px';
        
        // Force CSS Reflow
        element.offsetHeight;

        element.style.overflow = 'hidden';
        element.style.height = '0';
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';

        if (options?.addClasses && !options.addClassesAfterDuration) {
            element.classList.add(...options.addClasses);
        }

        if (options?.removeClasses && !options.removeClassesAfterDuration) {
            element.classList.remove(...options.removeClasses);
        }

        setTimeout( () => {
              element.style.display = 'none';
              element.style.removeProperty('height');
              element.style.removeProperty('padding-top');
              element.style.removeProperty('padding-bottom');
              element.style.removeProperty('margin-top');
              element.style.removeProperty('margin-bottom');
              element.style.removeProperty('overflow');
              element.style.removeProperty('transition-duration');
              element.style.removeProperty('transition-property');

            options?.callback?.();

            if (options?.addClasses && options.addClassesAfterDuration) {
                element.classList.add(...options.addClasses);
            }
            
            if (options?.removeClasses && options.removeClassesAfterDuration) {
                element.classList.remove(...options.removeClasses);
            }
        }, duration);
    }
};

export const slideDown = (element?: HTMLElement | null, duration: number = 200, options?: AnimationOptions) => {
    if (element) {
        element.style.removeProperty('display');
        const display = window.getComputedStyle(element).display;
        element.style.display = display === 'none' ? 'block' : display;

        const height = element.offsetHeight;
        
        element.style.overflow = 'hidden';
        element.style.height = '0';		
        element.style.paddingTop = '0';
        element.style.paddingBottom = '0';
        element.style.marginTop = '0';
        element.style.marginBottom = '0';
        
        // Force CSS Reflow
        element.offsetHeight;

        element.style.boxSizing = 'border-box';
        element.style.transitionProperty = 'height, margin, padding';
        element.style.transitionDuration = duration + 'ms';
        element.style.height = height + 'px';
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');

        if (options?.addClasses && !options.addClassesAfterDuration) {
            element.classList.add(...options.addClasses);
        }

        if (options?.removeClasses && !options.removeClassesAfterDuration) {
            element.classList.remove(...options.removeClasses);
        }

        setTimeout( () => {
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');

            options?.callback?.();

            if (options?.addClasses && options.addClassesAfterDuration) {
                element.classList.add(...options.addClasses);
            }
            
            if (options?.removeClasses && options.removeClassesAfterDuration) {
                element.classList.remove(...options.removeClasses);
            }
        }, duration);
    }
};

export const slideToggle = (element?: HTMLElement | null, duration = 200, options?: AnimationOptions) => {
    if (element) {
        if (window.getComputedStyle(element).display === 'none') {
            return slideDown(element, duration, options);
        } else {
            return slideUp(element, duration, options);
        }
    }
};

export const slideIn = (element?: HTMLElement | null, duration = 300, options?: SlideAnimationOptions) => {
    if (element) {
        element.style.removeProperty('display');
        const display = window.getComputedStyle(element).display;
        element.style.left = `-${element.offsetWidth}px`;
        element.style.display = 'none';
        element.style.removeProperty('display');

        element.style.left = `-${element.offsetWidth}px`;
        element.style.display = display === 'none' ? 'block' : display;
        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = options?.distance !== undefined ? `${options.distance}px` : '';

        document.documentElement.classList.add('mobile-behind');

        if (options?.addClasses && !options.addClassesAfterDuration) {
            element.classList.add(...options.addClasses);
        }

        if (options?.removeClasses && !options.removeClassesAfterDuration) {
            element.classList.remove(...options.removeClasses);
        }

        setTimeout(() => {
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            (element.querySelector('a, button') as HTMLButtonElement | null)?.focus();
            options?.callback?.();
            
            if (options?.addClasses && options.addClassesAfterDuration) {
                element.classList.add(...options.addClasses);
            }
            
            if (options?.removeClasses && options.removeClassesAfterDuration) {
                element.classList.remove(...options.removeClasses);
            }
        }, duration);
    }
};

export const slideOut = (element?: HTMLElement | null, duration = 300, options?: SlideAnimationOptions) => {
    if (element) {
        const distance = `-${window.getComputedStyle(element).width}`;

        element.style.transitionProperty = 'left';
        element.style.transitionDuration = duration + 'ms';
        element.style.left = distance;

        document.documentElement.classList.remove('mobile-behind');

        if (options?.addClasses && !options.addClassesAfterDuration) {
            element.classList.add(...options.addClasses);
        }

        if (options?.removeClasses && !options.removeClassesAfterDuration) {
            element.classList.remove(...options.removeClasses);
        }

        setTimeout(() => {
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            element.style.display = 'none';
            options?.toggle?.focus();

            options?.callback?.();

            if (options?.addClasses && options.addClassesAfterDuration) {
                element.classList.add(...options.addClasses);
            }
            
            if (options?.removeClasses && options.removeClassesAfterDuration) {
                element.classList.remove(...options.removeClasses);
            }
        }, duration);
    }
};


export const isVisible = (element: HTMLElement | null | undefined) => {
    if (!element || !element.isConnected)                                 return false;
    if (element.getClientRects().length === 0)                            return false;
    const style = getComputedStyle(element);
    if (style.visibility === 'hidden' || style.visibility === 'collapse') return false;
    const rect = element.getBoundingClientRect();
    if (rect.width === 0 || rect.height === 0)                            return false;
    if (style.opacity === '0')                                            return false;
    return true;
};